import * as $ from 'jquery';
import 'jquery-colorbox';

export default class residentialProjectListing {
	static initColorboxLightboxes() {
		if (!document.querySelector('.residentialProjectListing')) {
			return;
		}

		const listItems = document.querySelectorAll('.projectListItem--hasImage');
	
		for (let index = 0; index < listItems.length; index++) {
			const imageClasses = listItems[index].querySelector('.projectListItem__image').classList;

			let groupClass = null;

			for (var j = 0; j < imageClasses.length; j++) {
				if (imageClasses[j].match(/^group/)) {
					groupClass = imageClasses[j];
				}
			}

			$('.' + groupClass).colorbox({
				rel: groupClass,
				transition: 'elastic',
				initialWidth: '200',
				initialHeight: '200',
				width: '100%',
				height: '100%',
				maxWidth: '1000',
				maxHeight: '1000',
				fixed: true,
				close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.33 16.84">\
						<path fill="#fff" d="M13.46 15.34l1.48-1.49 15.35 15.34-1.49 1.49z" transform="translate(-12.96 -13.85)"/>\
						<path fill="#fff" d="M13 29.2l15.31-15.34 1.48 1.48-15.34 15.35z" transform="translate(-12.96 -13.85)"/>\
					</svg><span>Close</span>',
				previous: '\
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 332.57 570.29">\
						<path fill="#fff" d="M332.57 47.43a19.69 19.69 0 01-5.72 13.14L102.28 285.14l224.57 224.57a18 18 0 010 26.29l-28.57 28.57a18 18 0 01-26.28 0L5.71 298.29a18 18 0 010-26.29L272 5.71a18 18 0 0126.28 0l28.57 28.57a18.61 18.61 0 015.72 13.15z"/>\
					</svg>\
					<span>prev</span>',
				next: '\
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 332.57 570.28">\
						<path fill="#fff" d="M332.57 285.14a19.75 19.75 0 01-5.71 13.15L60.57 564.57a19.69 19.69 0 01-13.14 5.72 19.71 19.71 0 01-13.15-5.72L5.71 536A18.59 18.59 0 010 522.86a19.72 19.72 0 015.71-13.14l224.57-224.57L5.71 60.57a18 18 0 010-26.28L34.28 5.72A19.71 19.71 0 0147.43 0a19.69 19.69 0 0113.14 5.72L326.86 272a19.73 19.73 0 015.71 13.15z" />\
					</svg>\
					<span>next</span>',
				title: function() {
					return this.querySelector('img').getAttribute('title');
				},
				onOpen: function() {
					document.querySelector('html').classList.add('lockScroll');
				},
				onClosed: function() {
					document.querySelector('html').classList.remove('lockScroll');
				}
			});
		}
	}

	constructor() {
		residentialProjectListing.initColorboxLightboxes();
	}
}
